export class ProxyEmit {
  static use<EventName extends string>(emit?: (name: EventName, ...args: any[]) => void) {
    const vm = getCurrentInstance()
    const $emit =
      emit ||
      vm?.emit ||
      vm?.proxy?.$emit?.bind(vm?.proxy) ||
      ((n: EventName, ...rgs: any[]) => {
        console.log('Failed with no emit', vm)
      })

    return {
      $emit
    }
  }
}
